export default __webpack_public_path__ + "static/media/bannerYellow.4dd4cd35.png";